import moment from 'moment';
import React from 'react';
import { Modal, Button, Accordion, Table, Badge } from 'react-bootstrap';

const PaymentHistoryModal = ({ show, onClose, data }) => {
    console.log(data)
  

  return (
    <Modal show={show} onHide={onClose} centered size="">
      <Modal.Header closeButton>
        <Modal.Title>Payment History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Appointment Details */}
        <div className={"divider divider-start fw-medium"}>
            <span>Payment History Details</span>
        </div>
        <div className='d-flex align-items-cente gap-2'>
            <strong>Date:</strong>
            <div className="mb-0 d-flex gap-2 align-items-cente">
                <label className="d-block text-primary fs-sm mb-1">{moment(data?.createdAt).format("D MMM, YYYY")}</label>
                <h6>{moment(data?.createdAt).format("dddd, h:mm A")}</h6>
            </div>
        </div>
        <p className='mb-2'><strong>Service:</strong> {data?.description ?? "---"}</p>
        <p className='mb-2'><strong>Scheme:</strong> {data?.service?.hmo?.name ?? "---"} <span className='text-danger'>({data?.service?.hmo?.hmoType?.name ?? "---"})</span></p>
        <p className='mb-2'><strong>Amount:</strong> {data?.service?.tariff?.toLocaleString('en-NG', { style: 'currency', currency: 'NGN',})?? "---"} <span className='text-primary'>({data?.transaction_type?? "---"})</span></p>
        {/* <p className='mb-2'><strong>Amount:</strong><span className='text-primary'> {item?.service?.tariff?.toLocaleString('en-NG', { style: 'currency', currency: 'NGN',})?? "---"}</span></p> */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentHistoryModal;
